import { useState, useEffect, useCallback } from 'react';

export const useIsSmallMode = (breakpoint?: number) => {
  const [isSmallMode, setIsSmallMode] = useState<boolean>(false);
  const [contentWidth, setContentWidth] = useState<number>(0);

  // 834 is equivalent to the breakpoints.medium.max
  // Cannot import breakpoints from '@frontend/responsiveness' becuase of the module boundaries
  // Hence using hardcoded value
  const SMALL_MODE_BREAKPOINT = breakpoint ?? 834;

  const checkSmallMode = useCallback(() => {
    const mainContentElement = document.getElementById('main-content');

    if (mainContentElement) {
      setIsSmallMode(mainContentElement.clientWidth < SMALL_MODE_BREAKPOINT);
      setContentWidth(mainContentElement.clientWidth);
    } else {
      setIsSmallMode(false);
      setContentWidth(0);
    }
  }, [SMALL_MODE_BREAKPOINT]);

  useEffect(() => {
    checkSmallMode();

    const handleResize = () => {
      let timeoutId: NodeJS.Timeout | undefined;

      return () => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }

        timeoutId = setTimeout(() => {
          checkSmallMode();
        }, 200);
      };
    };

    const debouncedHandleResize = handleResize();
    window.addEventListener('resize', debouncedHandleResize);

    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, [checkSmallMode]);

  return {
    contentWidth,
    isSmallMode,
  };
};
